import { createSlice } from "@reduxjs/toolkit";
import {
  MenuInterface,
  ProfileInterface,
  SettingsInterface,
  IReward2Settings,
  IntervalOption,
  AmountOption,
  RewardStatus,
} from "../components/types";
import dayjs from "dayjs";

export interface StoreInterface {
  settings: SettingsInterface;
  selectedMenu: MenuInterface;
  isWalletOpen: boolean;
  profile: ProfileInterface;
  isInUS: boolean;
  snackMsg: string;
  rewardSettings: IReward2Settings;
}

export const initialRewardSettings: IReward2Settings = {
    _id: "",
    walletPubkey: "",
    rewardToken: "",
    amountOption: AmountOption.Static,
    staticAmount: "",
    minAmount: "",
    intervalOption: IntervalOption.Weekly,
    lastRewardDate: dayjs().toDate(),
    isEnableUs: false,
    percent2Us: "",
    usAddress: "",
    rewardVersion: 0,
    status: RewardStatus.None,
    msg: "",
    isEnable: true,
};

const initialState: StoreInterface = {
  settings: {
    mintingEnabled: undefined,
    levelRatios: [],
    rootSignupAddress: "",
    totalUsdc: 0,
    usdcMint: "",
    tokenMint: "",
    tokenRatio: 0,
    minSignupAmount: 0,
  },
  selectedMenu: MenuInterface.HOME,
  isWalletOpen: true,
  profile: {
    pubkey: "",
    isAdmin: false,
    balances: {},
    totalBalance: 0,
    nfts: [],
  },
  isInUS: false,
  snackMsg: "",
  rewardSettings: initialRewardSettings
};

export const mySlice = createSlice({
  name: "status",
  initialState: initialState,
  reducers: {
    setSettingsAction: (state, action) => {
      if (action.payload) {
        state.settings = { ...action.payload };
      }
    },
    setRewardSettingsAction: (state, action) => {
      if (action.payload) {
        state.rewardSettings = { ...action.payload };
      }
    },
    setProfileAction: (state, action) => {
      state.profile = { ...action.payload };
    },
    setSelectedMenuAction: (state, action) => {
      state.selectedMenu = action.payload;
    },
    setIsWalletOpenAction: (state, action) => {
      state.isWalletOpen = action.payload;
    },
    setIsInUSAction: (state, action) => {
      state.isInUS = action.payload;
    },
    setSnackMsgAction: (state, action) => {
      state.snackMsg = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSettingsAction,
  setProfileAction,
  setSelectedMenuAction,
  setIsWalletOpenAction,
  setIsInUSAction,
  setSnackMsgAction,
  setRewardSettingsAction,
} = mySlice.actions;

export default mySlice.reducer;
